import React from "react";
import { useSelector } from "react-redux";
import Table from "../../../../../components/coreUiTable/Table";
import { arrangePropsForTables } from "../utils/dataForTables";

const IntroConversionsTable = ()=>{
  const {data, colHeaders} = useSelector(state=>state.multiLocation.introConversions.tableInfo)

  return <Table {...arrangePropsForTables(data, colHeaders)}/>
}
export default IntroConversionsTable
